import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { sendEmail } from '../lib/attachments'
import { Icon, Spinner } from './ui'

const KEYS = ['mailbox1_email','mailbox1_password','mailbox1_name','mailbox1_operator_id','mailbox2_email','mailbox2_password','mailbox2_name','mailbox2_operator_id']

export default function Settings() {
  const [values, setValues] = useState({ mailbox1_email:'', mailbox1_password:'', mailbox1_name:'Amministrazione', mailbox1_operator_id:'', mailbox2_email:'', mailbox2_password:'', mailbox2_name:'Assistenza', mailbox2_operator_id:'' })
  const [profiles, setProfiles] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)
  const [saveErr, setSaveErr] = useState('')
  const [testEmail, setTestEmail] = useState('')
  const [testMailbox, setTestMailbox] = useState('1')
  const [testing, setTesting] = useState(false)
  const [testResult, setTestResult] = useState(null)

  useEffect(() => { loadSettings() }, [])

  const loadSettings = async () => {
    const [{ data }, { data: profs }] = await Promise.all([
      supabase.from('settings').select('key, value').in('key', KEYS),
      supabase.from('profiles').select('id, name, email').order('name')
    ])
    if (data) { const map = {}; data.forEach(r => map[r.key] = r.value || ''); setValues(prev => ({ ...prev, ...map })) }
    if (profs) setProfiles(profs)
    setLoading(false)
  }

  const saveSettings = async () => {
    setSaving(true); setSaved(false); setSaveErr('')
    const upserts = KEYS.map(key => ({ key, value: values[key], updated_at: new Date().toISOString() }))
    const { error } = await supabase.from('settings').upsert(upserts, { onConflict: 'key' })
    setSaving(false)
    if (error) { setSaveErr(error.message || 'Errore durante il salvataggio'); return }
    setSaved(true)
    setTimeout(() => setSaved(false), 3000)
  }

  const sendTest = async () => {
    if (!testEmail) return
    setTesting(true); setTestResult(null)
    const mailboxEmail = testMailbox === '1' ? values.mailbox1_email : values.mailbox2_email
    try {
      await sendEmail({ type: 'test', to: testEmail, mailbox: mailboxEmail })
      setTestResult('success')
    } catch (e) { setTestResult('error: ' + e.message) }
    setTesting(false)
  }

  const set = (key, val) => setValues(prev => ({ ...prev, [key]: val }))

  // Funzione chiamata (non componente) per non rimontare i campi a ogni tasto
  const renderMailbox = (num, defaultName) => {
    const configured = !!(values[`mailbox${num}_email`] && values[`mailbox${num}_password`])
    return (
      <div className="card">
        <div className="card-header">
          <div className="row" style={{ gap: 12 }}>
            <span className="mbox-ico" style={{ background: num === 1 ? '#eef2ff' : '#ecfdf3', color: num === 1 ? '#4f46e5' : '#079455' }}><Icon name="mail" size={18} /></span>
            <div>
              <div className="card-title">{values[`mailbox${num}_name`] || defaultName}</div>
              <div className="card-sub">Casella {num}</div>
            </div>
          </div>
          {configured
            ? <span className="tag tag-customer"><Icon name="check" size={12} style={{ marginRight: 4 }} /> Configurata</span>
            : <span className="tag" style={{ background: 'var(--surface-3)', color: 'var(--text-3)' }}>Da configurare</span>}
        </div>
        <div className="card-body">
          <label className="field">
            <span className="label">Nome mittente</span>
            <input className="input" placeholder={defaultName} value={values[`mailbox${num}_name`]} onChange={e => set(`mailbox${num}_name`, e.target.value)} />
          </label>
          <label className="field">
            <span className="label">Indirizzo email</span>
            <input className="input" type="email" placeholder={`${defaultName.toLowerCase()}@easytechonline.it`} value={values[`mailbox${num}_email`]} onChange={e => set(`mailbox${num}_email`, e.target.value)} />
          </label>
          <label className="field">
            <span className="label">Password</span>
            <input className="input" type="password" placeholder="••••••••" value={values[`mailbox${num}_password`]} onChange={e => set(`mailbox${num}_password`, e.target.value)} />
          </label>
          <label className="field">
            <span className="label">Operatore assegnato</span>
            <select className="select" value={values[`mailbox${num}_operator_id`] || ''} onChange={e => set(`mailbox${num}_operator_id`, e.target.value)}>
              <option value="">— Nessuno —</option>
              {profiles.map(p => <option key={p.id} value={p.id}>{p.name || p.email}</option>)}
            </select>
            <span className="hint">I ticket in arrivo su questa casella vengono assegnati e notificati a questo operatore.</span>
          </label>
          <div className="server-note"><Icon name="shield" size={13} /> IMAP imaps.aruba.it:993 · SMTP smtps.aruba.it:465</div>
        </div>
      </div>
    )
  }

  if (loading) return <div className="empty"><Spinner size={22} /></div>

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Impostazioni</h1>
          <p className="page-sub">Caselle email per la ricezione automatica e l'invio delle risposte</p>
        </div>
        <button className="btn btn-primary" onClick={saveSettings} disabled={saving}>
          {saving ? <Spinner size={14} /> : <Icon name={saved ? 'check' : 'save'} size={15} />}
          {saving ? 'Salvataggio…' : saved ? 'Salvato' : 'Salva impostazioni'}
        </button>
      </div>

      {(saved || saveErr) && (
        <div className="savebar">
          {saved && <div className="alert alert-success" style={{ flex: 1 }}><Icon name="checkCircle" size={16} /> Impostazioni salvate</div>}
          {saveErr && <div className="alert alert-error" style={{ flex: 1 }}><Icon name="alert" size={16} /> {saveErr}</div>}
        </div>
      )}

      <div className="settings-grid">
        {renderMailbox(1, 'Amministrazione')}
        {renderMailbox(2, 'Assistenza')}
      </div>

      <div className="card" style={{ maxWidth: 560 }}>
        <div className="card-header">
          <div>
            <div className="card-title">Prova invio email</div>
            <div className="card-sub">Verifica che la casella invii correttamente</div>
          </div>
          <span className="kpi-icon" style={{ background: 'var(--accent-soft)', color: 'var(--accent)' }}><Icon name="send" size={16} /></span>
        </div>
        <div className="card-body">
          <label className="field">
            <span className="label">Invia da</span>
            <select className="select" value={testMailbox} onChange={e => setTestMailbox(e.target.value)}>
              <option value="1">Casella 1 — {values.mailbox1_name || 'Amministrazione'}</option>
              <option value="2">Casella 2 — {values.mailbox2_name || 'Assistenza'}</option>
            </select>
          </label>
          <label className="field">
            <span className="label">Destinatario di prova</span>
            <input className="input" type="email" placeholder="tuaemail@esempio.it" value={testEmail} onChange={e => setTestEmail(e.target.value)} />
          </label>
          <button className="btn btn-secondary" onClick={sendTest} disabled={testing || !testEmail}>
            {testing ? <Spinner size={14} /> : <Icon name="send" size={15} />} {testing ? 'Invio…' : 'Invia email di prova'}
          </button>
          {testResult && (
            <div className={`alert ${testResult === 'success' ? 'alert-success' : 'alert-error'}`} style={{ marginTop: 14 }}>
              <Icon name={testResult === 'success' ? 'checkCircle' : 'alert'} size={16} />
              {testResult === 'success' ? 'Email inviata correttamente.' : testResult}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
